import * as types from './constants';

// Create Merchant
export const createMerchantRequest = data => (
  { type: types.CREATE_MERCHANT_REQUEST, payload: data }
);

export const createMerchantDone = data => (
  { type: types.CREATE_MERCHANT_DONE, payload: data }
);

export const createMerchantFailed = errors => (
  { type: types.CREATE_MERCHANT_FAILED, payload: errors }
);